import $ from 'jquery';
import StoreService from '../service/StoreService';
import CatalogDetailService from '../service/CatalogDetailService';
import HistoryManager from '../util/HistoryManager';

if ($('.catalog-detail').length) {
    CatalogDetailService.init();
    CatalogDetailService.loadOffers();

    StoreService.onChange(() => {
        const { productCode } = CatalogDetailService;

        CatalogDetailService.getItem(productCode)
            .then(response => response.items[0])
            .then((item) => {
                CatalogDetailService.renderPrice(item.price);
                CatalogDetailService.renderPoints(item.points);
                CatalogDetailService.renderAvailable(item.available);
            });

        CatalogDetailService.loadOffers();
    });

    window.addEventListener('popstate', () => {
        const activeClassname = 'catalog-detail-offers__item--active';
        const offer = CatalogDetailService.offersByUrl[window.location.pathname];

        $('.catalog-detail-offers__item').removeClass(activeClassname);

        if (offer) {
            CatalogDetailService.renderOffer(offer);
            $(`.catalog-detail-offers__item--${offer.id}`).addClass(activeClassname);
        }
    }, false);
}

$('.catalog-detail-offers__item').click(function () {
    const activeClassname = 'catalog-detail-offers__item--active';
    if ($(this).hasClass(activeClassname)) {
        return;
    }

    $('.catalog-detail-offers__item').removeClass(activeClassname);
    $(this).addClass(activeClassname);

    const offer = CatalogDetailService.offersByCode[$(this).attr('data-code')];
    if (offer) {
        HistoryManager.push(offer.url);
        CatalogDetailService.renderOffer(offer);
    }
});
